module.exports = __webpack_public_path__ + "static/img/join_1.80faf27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_1.jpg
// module id = kKM3
// module chunks = 1